import React, {ComponentProps} from "react";
import StandardTable, {StandardColumnsType} from "../../../components/StandardTable";
import useAntTable from "../../../utils/useAntTable";
import * as api from "../../../apis/platforms/admin/warehouseVoucher";
import dayjs from "dayjs";

type WarehouseTabProps = ComponentProps<any> & {
    orderNo: string
}

function WarehouseTab(props: WarehouseTabProps) {

    const orderNo = props.orderId
    const {tableProps} = useAntTable(api.getVoucherBySales, {
        method: 'post',
        defaultParams: {orderNo: orderNo}
    })

    const columns: StandardColumnsType = [
        {
            title: "入库单号",
            dataIndex: "no",
        },
        {
            title: "入库日期",
            dataIndex: "date",
            render: (value) => dayjs(value).format("lll"),
        },
        {
            title: "客户名称",
            dataIndex: "dealerName",
        },
        {
            title: "行号",
            dataIndex: "lineNumber",
        },
        {
            title: "物料编码",
            dataIndex: "productNo",
        },
        {
            title: "物料名称",
            dataIndex: "productName",
        },
        {
            title: "实收数量",
            dataIndex: "qty",
        },
        {
            title: "订单号",
            dataIndex: "orderNo",
        },
        {
            title: "订单行号",
            dataIndex: "orderLineNumber",
        },
    ]

    return (
        <StandardTable rowKey={'id'} showCard={false} columns={columns} {...tableProps}/>
    )
}

export default WarehouseTab;
